import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'

// le decimos a vue que usaremos la libreria vuex
Vue.use(Vuex)

export default new Vuex.Store({
    // aca definimos nuestros estados, especie de variables
    state: {
        logo: '/static/img/logo_apc.png',
    },
    // definimos los metodos que retornaran los valores de nuestros estados
    getters: {
    },
    // definimos los metodos para modificar (mutar) nuestros estados
    mutations: {
        SET_LOGO (state, logo) {
            state.logo = logo
        },
    },
    // definimos las acciones, funciones que hacen uso de nuestros estados
    actions: {
    },
    // definimos los modulos donde podremos organizar mejor nuestro ecosistema vuex
    modules: {
        auth,
    }
})
